document.addEventListener('DOMContentLoaded', function () {
    var collectionContainer = document.querySelector('.mm-collection-content-container');
    var readMoreText = collectionContainer.dataset.readMore;

    const description = document.querySelector('.mm-collection-banner-description');
    const readMoreBtn = document.createElement('span');
    readMoreBtn.classList.add('mm-read-more');
    readMoreBtn.innerText = readMoreText;

    if (description.scrollHeight > description.clientHeight) {
    description.parentNode.appendChild(readMoreBtn);
    }

    readMoreBtn.addEventListener('click', function () {
    description.classList.add('expanded');
    readMoreBtn.classList.add('hidden');
    });
});